import React, { useContext } from 'react'
import {
    Stack,
    Box,
    Typography,
} from '@mui/material'

import { ThemeContext } from '../../context/theme/context.js'
import Header from '../../utils/header.js'

import data from '../../data/portfolio.json'

const Experience = () => {
    const { state } = useContext(ThemeContext)

    return <Box>
        <Header
            color={state.color.primary}
            title='CONTATCS' />
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            width="100%"
            spacing={{ xs: 1, sm: 2, md: 4 }}
            justifyContent={{xs: 'flex-start', md: "space-between"}}
            alignItems={{xs: 'flex-start', md: "center"}}>
            <Stack
                direction={{ xs: 'column' }}
                width={{ xs: "100%", md: "20%" }}
            >
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 16, md: 24 },
                        fontWeight: 700,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.gmail.title}
                </Typography>
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 14, md: 18 },
                        fontWeight: 100,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.gmail.data}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column' }}
                width={{ xs: "100%", md: "20%" }}
            >
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 16, md: 24 },
                        fontWeight: 700,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.address.title}
                </Typography>
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 14, md: 18 },
                        fontWeight: 100,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.address.data}
                </Typography>
            </Stack>
            <Stack
                direction={{ xs: 'column' }}
                width="20%"
            >
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 16, md: 24 },
                        fontWeight: 700,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.whatsapp.title}
                </Typography>
                <Typography
                    color={state.color.primary}
                    fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
                    sx={{
                        fontSize: { xs: 14, md: 18 },
                        fontWeight: 100,
                        letterSpacing: '0.05em',
                        // textAlign: 'center',
                        // textTransform: 'uppercase',
                        // '&:hover': {
                        //     color: state.color.primary
                        // }
                    }}
                >
                    {data.whatsapp.data}
                </Typography>
            </Stack>
        </Stack >
    </Box >
}

export default Experience